import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const SearchIcon = ({
  title = 'Search',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    {/* prettier-ignore */}
    <path fillOpacity=".01" d="M0 0h24v24H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.042.667a9.376 9.376 0 000 18.751 9.333 9.333 0 005.448-1.744l5.205 5.206.074.07a1.546 1.546 0 002.112-2.256l-5.206-5.205a9.334 9.334 0 001.743-5.447A9.376 9.376 0 0010.042.668zm0 3.09a6.285 6.285 0 110 12.57 6.285 6.285 0 010-12.57z"
    />
  </CreateIconComponent>
);

export default SearchIcon;
